import { getAnalytics, logEvent as firebaseLogEvent } from "firebase/analytics";
import { firebaseApp } from "./firebase";

const analytics = getAnalytics(firebaseApp);

export const logEvent = (event, params) => {
  if (process.env.NODE_ENV === "production") {
    firebaseLogEvent(analytics, event, params);
  } else {
    console.log("Dev mode analytics event:", event, params);
  }
};
